import React from 'react';
import PropTypes from 'prop-types';

import {frefFromRef} from '../react/higher-order-components';
import OEToolbox from '../tools/oe-toolbox-core';

export class OEResizeObserverIFrame extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onResize = this.onResize.bind(this);
        this.onContentWindowResize = this.onContentWindowResize.bind(this);
        this.onRef = this.onRef.bind(this);
    }

    componentDidMount()    {
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount()    {
        window.removeEventListener('resize', this.onResize);
        let size = {w: 0, h: 0};
        if(OEToolbox.shallowEqual(this.size, size))   return;
        this.size = size;
        if(this.props.onResize) this.props.onResize(this, this.size);
    }

    getElementRef()    {
        this.ref;
    }

    getSize()   {
        return this.size ? this.size : {w: 0, h: 0};
    }

    getWidth()   {
        return this.size ? this.size.w : 0;
    }

    getHeight()   {
        return this.size ? this.size.h : 0;
    }

    getClientPos()  {
        if(!this.ref) return;
        const rect = this.ref.getBoundingClientRect();
        return {x: rect.left, y: rect.top};
    }

    updateSize()    {
        if(!this.ref || !this.ref.contentWindow)   return;

        const rect = this.ref.getBoundingClientRect();
        let size = {w: rect.right - rect.left, h: rect.bottom - rect.top};

        if(size.w === 0 && size.h === 0)     size = {w: this.ref.contentWindow.innerWidth, h: this.ref.contentWindow.innerHeight};

        if(OEToolbox.shallowEqual(this.size, size))   return;
        this.size = size;
        if(this.props.onResize) this.props.onResize(this, this.size);
    }

    onResize() {
        this.updateSize();
    }

    onContentWindowResize() {
        this.updateSize();
    }

    onRef(ref) {
        if(this.ref === ref) return;

        if(this.ref && this.ref.contentWindow)    {
            this.ref.contentWindow.removeEventListener('resize', this.onContentWindowResize);
        }

        this.ref = ref;

        if(this.ref && this.ref.contentWindow)    {
            this.ref.contentWindow.addEventListener('resize', this.onContentWindowResize);
            this.updateSize();
        }
    }

    render() {
        // use opacity: 0 instead of visibility: hidden because some browsers, e.g., firefox, don't update the window size otherwise
        const style = Object.assign({position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, border: 'none', padding: '0', margin: '0', pointerEvents: 'none'}, this.props.style);

        return (
            <iframe
                className={this.props.className}
                style={style}
                ref={this.onRef}
                src="about:blank"
            />
        );
    }
}

OEResizeObserverIFrame.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    onResize: PropTypes.func
};

//
export class OEResizeObserver extends React.PureComponent {

    constructor(props) {
        super(props);

        this.resizeObserverCallback = this.resizeObserverCallback.bind(this);
        this.resizeObserver = new ResizeObserver(this.resizeObserverCallback);

        this.onResize = this.onResize.bind(this);
        this.onRef = this.onRef.bind(this);
    }

    componentDidMount()    {
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount()    {
        window.removeEventListener('resize', this.onResize);
        this.resizeObserver.disconnect();
        let size = {w: 0, h: 0};
        if(OEToolbox.shallowEqual(this.size, size))   return;
        this.size = size;
        if(this.props.onResize) this.props.onResize(this, this.size);
    }

    getElementRef()    {
        this.ref;
    }

    getSize()   {
        return this.size ? this.size : {w: 0, h: 0};
    }

    getWidth()   {
        return this.size ? this.size.w : 0;
    }

    getHeight()   {
        return this.size ? this.size.h : 0;
    }

    getClientPos()  {
        if(!this.ref) return;
        const rect = this.ref.getBoundingClientRect();
        return {x: rect.left, y: rect.top};
    }

    updateSize()    {
        if(!this.ref)   return;

        const rect = this.ref.getBoundingClientRect();
        let size = {w: rect.right - rect.left, h: rect.bottom - rect.top};

        if(OEToolbox.shallowEqual(this.size, size))   return;
        this.size = size;
        if(this.props.onResize) this.props.onResize(this, this.size);
    }

    resizeObserverCallback()    {
        this.updateSize();
    }

    onResize() {
        this.updateSize();
    }

    onRef(ref) {
        if(this.ref === ref) return;

        if(this.ref)    this.resizeObserver.unobserve(this.ref);
        this.ref = ref;

        if(this.ref)    {
            this.resizeObserver.observe(this.ref)
            this.updateSize();
        }
    }

    render() {
        // use opacity: 0 instead of visibility: hidden because some browsers, e.g., firefox, don't update the window size otherwise
        const style = Object.assign({position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, border: 'none', padding: '0', margin: '0', pointerEvents: 'none'}, this.props.style);

        return (
            <div
                className={this.props.className}
                style={style}
                ref={this.onRef}
            />
        );
    }
}

OEResizeObserver.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    onResize: PropTypes.func
};

//
export class OEResizeObserverSelector extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            userIFrameFallback: ResizeObserver === undefined
        };
    }

    render() {
        return !this.state.userIFrameFallback ?
            <OEResizeObserver {...this.props} ref={this.props.fref}/> :
            <OEResizeObserverIFrame {...this.props} ref={this.props.fref}/>;
    }
};

OEResizeObserverSelector.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    onResize: PropTypes.func
};

//
export default frefFromRef(OEResizeObserverSelector);